import { Link } from "react-router-dom";
import type { Film } from "@/types/content";

interface FilmCardProps {
  film: Film;
  showPopularity?: boolean;
  showIntro?: boolean;
}

export default function FilmCard({ film, showPopularity = false, showIntro = true }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={film.poster}
          alt={`${film.title}海报`}
          title={`${film.title} 妖精影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-70" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {film.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-semibold text-accent-600">
          <i className="ri-star-fill text-accent-500" />
          {film.rating.toFixed(1)}
        </span>
        <p className="absolute bottom-2 left-2 right-2 line-clamp-2 text-xs leading-snug text-background-100">
          {film.intro}
        </p>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {film.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{film.year}</span>
          <span className="text-background-300">·</span>
          <span className="line-clamp-1">{film.region}</span>
          {showPopularity && (
            <>
              <span className="text-background-300">·</span>
              <span className="flex items-center gap-1 text-accent-600">
                <i className="ri-fire-fill" />
                {(film.popularity / 1000).toFixed(1)}k
              </span>
            </>
          )}
        </div>
        {showIntro && (
          <p className="line-clamp-1 text-xs text-foreground-500">导演：{film.director}</p>
        )}
      </div>
    </Link>
  );
}